const stylesConfig = {
  contentMaxWidth: '48rem',
}

export default stylesConfig



// WEBPACK FOOTER //
// ./src/styles/config.js